import { createContext, useContext, useState, type ReactNode } from 'react';

export interface StoryHeaderProgress {
  value: number;
  max: number;
}

interface StoryBottomBarContextValue {
  content: ReactNode;
  setContent: (content: ReactNode) => void;
  hideFade: boolean;
  setHideFade: (value: boolean) => void;
  hideCloseButton: boolean;
  setHideCloseButton: (value: boolean) => void;
  /** Optional progress bar shown inside the header (set by activity pages, hidden by default). */
  headerProgress: StoryHeaderProgress | null;
  setHeaderProgress: (progress: StoryHeaderProgress | null) => void;
}

const StoryBottomBarContext = createContext<StoryBottomBarContextValue | null>(null);

export function StoryBottomBarProvider({ children }: { children: ReactNode }) {
  const [content, setContent] = useState<ReactNode>(null);
  const [hideFade, setHideFade] = useState(false);
  const [hideCloseButton, setHideCloseButton] = useState(false);
  const [headerProgress, setHeaderProgress] = useState<StoryHeaderProgress | null>(null);
  return (
    <StoryBottomBarContext.Provider
      value={{
        content,
        setContent,
        hideFade,
        setHideFade,
        hideCloseButton,
        setHideCloseButton,
        headerProgress,
        setHeaderProgress,
      }}
    >
      {children}
    </StoryBottomBarContext.Provider>
  );
}

export function useStoryBottomBar() {
  const ctx = useContext(StoryBottomBarContext);
  return ctx;
}
